import { IStateStore } from 'models/global';

export const getUserInfo = (state: IStateStore) => state.global.userInfo;

export const getNavMenu = (state: IStateStore) => state.global.navMenu;

export const getSideMenu = (state: IStateStore) => {
  const { pathname } = state.router.location;
  const selectMenu = state.global.navMenu.find((menu: any) => new RegExp(`^${menu.path}`).test(pathname));
  if (selectMenu) {
    return selectMenu.children || [];
  }
  return [];
};

export const getAuthority = (state: IStateStore) => state.global.authority;

export const getConfigDicts = (state: IStateStore) => state.global.configDicts;

export const getPearConfigDicts = (state: IStateStore) => state.global.pearConfigDicts;

export const getAdAccountInfo = (state: IStateStore) => state.global.adAccountInfo;

export const getCurrency = (state: IStateStore) => state.global.currency;

export const getCurrencyConfig = (state: IStateStore) => state.global.currencyConfig;

export const getHeaderBadgeCount = (state: IStateStore) => state.global.headerBadgeCount;

export const getHeaderMsg = (state: IStateStore) => state.global.headerMsg;

export const getCenterMsg = (state: IStateStore) => state.global.centerMsg;

export const getFundIds = (state: IStateStore) => state.global.fundIds;

export const getTimezone = (state: IStateStore) => state.global.timezone;

// 公共模块
export const getCommonSpinning = (state: IStateStore) => !!state.global.spinning;
export const getCommonOnlySpinning = (state: IStateStore) => !!state.global.onlySpinning;

// 广告投放模块
export const getAdvertFormStep = (state: IStateStore) => state.global.advertFormStep;
export const getAdvertSkan = (state: IStateStore) => state.global.skan;
export const getDelayedEvents = (state: IStateStore) => state.global.delayedEvents;
export const getAdvertConfirmPre = (state: IStateStore) => state.global.advertConfirmPre;
